import { useState } from 'react';
import { useRouter } from 'next/router';

import { billingPeriodOptions } from '../billing-period-toggle';

export const useBillingPeriod = () => {
    const {
        query: { billing },
    } = useRouter();

    const state = useState<'1' | '12'>(billing && billingPeriodOptions().findIndex((b) => b.value === billing) >= 0 ? billing.toString() as '1' : billingPeriodOptions()[0].value as '1');

    return state;
};
